import { useSelector } from 'react-redux';
import {
  ADMIN_CONTACT_NET_ROLES_OPTIONS,
  ADMIN_CONTACT_PARTNER,
  ADMIN_CONTACT_SCHOOL,
  ADMIN_CONTACT_SCHOOL_ALL_BRANCHES_ROLES_OPTIONS,
  ADMIN_CONTACT_SCHOOL_BRANCH_ROLES_OPTIONS
} from '../../../constants/admin.contacts.constants';
import { ALL_SELECT_OPTION } from '../../../constants/settings.constants';
import { currentUserSelector } from '../../../selectors/auth.selectors';
import { INPUT_STATES } from '../../forms/forms.utils';
import SelectField from '../../forms/SelectField';
import TextField from '../../forms/TextField';
import AdminContactSearchSchool from './AdminContactSearchSchool';

const AdminContactSchoolFields = ({
  data,
  type,
  isSubmitting,
  onInput,
  netsDependency,
  managementsDependency,
  communitiesDependency,
  schoolsDependency,
  branchesDependency,
  parentElement
}) => {
  const currentUser = useSelector(currentUserSelector);
  const isCurrentUserPartner = currentUser?.type === ADMIN_CONTACT_PARTNER;

  if (type !== ADMIN_CONTACT_SCHOOL) {
    return null;
  }

  const onNetChange = (value) => {
    onInput(ALL_SELECT_OPTION.value, 'management');
    onInput(ALL_SELECT_OPTION.value, 'community');
    onInput(ALL_SELECT_OPTION.value, 'school');
    onInput(ALL_SELECT_OPTION.value, 'branch');
    onInput(value, 'net');
  };

  const onManagementChange = (value) => {
    onInput(ALL_SELECT_OPTION.value, 'community');
    onInput(ALL_SELECT_OPTION.value, 'school');
    onInput(ALL_SELECT_OPTION.value, 'branch');
    onInput(value, 'management');
  };

  const onCommunityChange = (value) => {
    onInput(ALL_SELECT_OPTION.value, 'school');
    onInput(ALL_SELECT_OPTION.value, 'branch');
    onInput(value, 'community');
  };

  const onSchoolChange = (value) => {
    onInput(ALL_SELECT_OPTION.value, 'branch');
    onInput(value, 'school');
  };

  const onBranchChange = (value) => {
    if (value !== ALL_SELECT_OPTION.value) {
      onInput('', 'role');
    }
    onInput(value, 'branch');
  };

  const handleSearchSelect = (selected) => {
    if (selected?.schoolId) {
      onInput(selected?.netId, 'net');
      onInput(selected?.managementId, 'management');
      onInput(selected?.communityId, 'community');
      onInput(selected?.schoolId, 'school');
      onInput(ALL_SELECT_OPTION.value, 'branch');
      return;
    }

    if (selected?.communityId) {
      onInput(selected?.netId, 'net');
      onInput(selected?.managementId, 'management');
      onInput(selected?.communityId, 'community');
      onInput(ALL_SELECT_OPTION.value, 'school');
      onInput(ALL_SELECT_OPTION.value, 'branch');
      return;
    }

    if (selected?.managementId) {
      onInput(selected?.netId, 'net');
      onInput(selected?.managementId, 'management');
      onInput(ALL_SELECT_OPTION.value, 'community');
      onInput(ALL_SELECT_OPTION.value, 'school');
      onInput(ALL_SELECT_OPTION.value, 'branch');
      return;
    }

    if (selected?.netId) {
      onInput(selected?.netId, 'net');
      onInput(ALL_SELECT_OPTION.value, 'management');
      onInput(ALL_SELECT_OPTION.value, 'community');
      onInput(ALL_SELECT_OPTION.value, 'school');
      onInput(ALL_SELECT_OPTION.value, 'branch');
      return;
    }
  };

  const hasOnlyNetSelected =
    data?.net &&
    (!data?.management || data?.management === ALL_SELECT_OPTION.value) &&
    (!data?.community || data?.community === ALL_SELECT_OPTION.value) &&
    (!data?.school || data?.school === ALL_SELECT_OPTION.value) &&
    (!data?.branch || data?.branch === ALL_SELECT_OPTION.value);
  const shouldShowRolesDropdown =
    !isCurrentUserPartner &&
    (hasOnlyNetSelected || (data?.net && data?.school && data?.school !== ALL_SELECT_OPTION.value));

  const getRolesOptions = () => {
    if (data?.school && data?.school !== ALL_SELECT_OPTION.value) {
      return data?.branch === ALL_SELECT_OPTION.value && !isCurrentUserPartner
        ? ADMIN_CONTACT_SCHOOL_ALL_BRANCHES_ROLES_OPTIONS
        : ADMIN_CONTACT_SCHOOL_BRANCH_ROLES_OPTIONS;
    }

    if (hasOnlyNetSelected && !isCurrentUserPartner) {
      return ADMIN_CONTACT_NET_ROLES_OPTIONS;
    }

    return [];
  };

  return (
    <>
      <AdminContactSearchSchool onSelect={handleSearchSelect} />
      <SelectField
        id="add-contact-modal-schoolnet"
        label="Net"
        name={'net'}
        required
        onChange={onNetChange}
        disableSearch={true}
        options={netsDependency.options}
        value={data?.net}
        className="u-margin-bottom u-margin-top"
        disabled={netsDependency.isLoading || isSubmitting}
        isSubmitting={netsDependency.isLoading || isSubmitting}
        parentElement={parentElement}
      />
      {!!data?.net && data?.net !== ALL_SELECT_OPTION.value && (
        <SelectField
          id="add-contact-modal-schoolmanagement"
          label="Schoolbestuur"
          name={'management'}
          onChange={onManagementChange}
          disableSearch={true}
          options={managementsDependency.options?.filter((management) => data?.net === management.netId)}
          isSubmitting={managementsDependency.isLoading || isSubmitting}
          value={data?.management}
          className="u-margin-top u-margin-bottom"
          disabled={managementsDependency.isLoading || isSubmitting}
          parentElement={parentElement}
          allOption
        />
      )}
      {!!data?.net && !!data?.management && data?.management !== ALL_SELECT_OPTION.value && (
        <SelectField
          id="add-contact-modal-schoolcommunity"
          label="Scholengemeenschap"
          name={'community'}
          onChange={onCommunityChange}
          disableSearch={true}
          options={communitiesDependency.options?.filter(
            (community) =>
              (data?.management === ALL_SELECT_OPTION.value && data?.net === community.netId) ||
              data?.management === community.managementId
          )}
          isSubmitting={communitiesDependency.isLoading || isSubmitting}
          value={data?.community}
          className="u-margin-top u-margin-bottom"
          disabled={communitiesDependency.isLoading || isSubmitting}
          parentElement={parentElement}
          allOption
        />
      )}
      {!!data?.net && !!data?.management && !!data?.community && data?.community !== ALL_SELECT_OPTION.value && (
        <SelectField
          id="add-contact-modal-school"
          label="School"
          name={'school'}
          onChange={onSchoolChange}
          disableSearch={true}
          options={schoolsDependency.options?.filter(
            (school) =>
              (data?.community === ALL_SELECT_OPTION.value && data?.management === school.managementId) ||
              data?.community === school.communityId
          )}
          isSubmitting={schoolsDependency.isLoading || isSubmitting}
          value={data?.school}
          className="u-margin-top u-margin-bottom"
          disabled={schoolsDependency.isLoading || isSubmitting}
          parentElement={parentElement}
          allOption
        />
      )}
      {!!data?.net &&
        !!data?.management &&
        !!data?.community &&
        !!data?.school &&
        data?.school !== ALL_SELECT_OPTION.value && (
          <SelectField
            id="add-contact-modal-schoolBranch"
            label="Vestiging"
            name={'branch'}
            description="Selecteer optie “Alle” indien je “School Admin” rechten wilt toekennen."
            onChange={onBranchChange}
            disableSearch={true}
            options={branchesDependency.options?.filter(
              (branch) =>
                (data?.school === ALL_SELECT_OPTION.value && data?.community === branch.communityId) ||
                data?.school === branch.schoolId
            )}
            isSubmitting={branchesDependency.isLoading || isSubmitting}
            value={data?.branch}
            className="u-margin-top u-margin-bottom"
            disabled={branchesDependency.isLoading || isSubmitting}
            parentElement={parentElement}
            allOption
          />
        )}
      <TextField
        label="Functie"
        name={'function'}
        value={data.function}
        state={INPUT_STATES.DEFAULT}
        className="u-margin-top"
        // onKeyDown={onEnter}
        onChange={(value) => onInput(value, 'function')}
        disabled={isSubmitting}
      />
      {!(hasOnlyNetSelected && isCurrentUserPartner) && shouldShowRolesDropdown && (
        <SelectField
          id="add-contact-modal-role"
          label="Rechten"
          name={'role'}
          onChange={(value) => onInput(value, 'role')}
          disableSearch={true}
          options={getRolesOptions()}
          parentElement={parentElement}
          value={data.role}
          className="u-margin-top"
          disabled={isSubmitting}
        />
      )}
    </>
  );
};

export default AdminContactSchoolFields;
